var stayInformed = stayInformed || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F();
        };
    })();
}

jQuery(function ( $ ) {
 
    $.fn.stForm = function( options ) {
        return this.each(function() {
            var stForm = Object.create(stayInformed.stForm);
            stForm.init(this, options);
        });
    };

    $.fn.stForm.options = {

     };

    stayInformed.stForm = {

        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);
            self.$form = self.$container.find(".connect-form");
            self.$inputs = self.$container.find(".connect-form__input");
            
            self.$HasError = true;

            self.bindElements();
        },

        bindElements () {
            var self = this;

            self.$form.on("submit", function() {
                self.validate();
                return self.$HasError;
            });

            self.$inputs.on("focus keydown", function() { 
                $(this).parent().removeClass("has-error")
            });
        },

        validate() {
            var self = this;
            
            self.$inputs.each(function(i,v) {

                if ( v.type === "email" ) {
                    self.validateEmail(v);
                } else {
                    self.validateText(v);
                }
             });
        },

        validateText(input) {
            var self = this;
            var reg =  /^[a-zA-Z]+$/,
                textTest = reg.test( input.value );
            if( input.value.trim() === "" || !textTest) {
                self.errorThrown( input );
            } else {
                self.$HasError = true;
            }
        },
    
        validateEmail (input ) {
            var self = this;
            var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            var emailTest = re.test( input.value );
            var errorTag = $(input).next(".connect-form__error")
            
            if (  $(input).val().trim() === "" ) {
                self.errorThrown( input );
                $(errorTag).text( $(errorTag).data("empty") );
            }  else if ( $(input).val().length > 0 && !emailTest ) {
                self.errorThrown( input );
                $(errorTag).text( $(errorTag).data("invalid") );
            } else {
                self.$HasError = true;
                return true;
            }

        },
        errorThrown(input) {
            var self = this;
            self.$HasError = false;
            $(input).parent().addClass("has-error");
            return false;
        },
    };
});
